// extracted by mini-css-extract-plugin
export default {"table":"Table_table__KgZmk","image":"Table_image__SC5YW","icon":"Table_icon__JRoXz","titleTd":"Table_titleTd__OaD4q"};